<template>
  <BaseQuantitySelector v-model="quantity" />

  <BaseButton
    :text="$t('testDetail.AddToCart')"
    class="w-full sm:text-[22px] text-[18px]"
    :disabled="quantity === 0"
    @click="handleAddToCart(product)"
  ></BaseButton>
</template>

<script setup lang="ts">
import { useCartStore, type CartItem as CartItemType } from "@/stores/cart";
import type { PropType } from "vue";

interface Product {
  id: number | null;
  test_title: string;
  service_title: string;
  price: number;
  net_price?: number;
  discount?: number;
}

const cartStore = useCartStore();
const quantity = ref<number>(1);

const props = defineProps({
  product: {
    type: Object as PropType<Omit<CartItemType, "quantity">>,
    required: true,
  },
});

const handleAddToCart = (serviceData: Product) => {
  const cartItem = {
    ...serviceData,
    quantity: quantity.value,
  };

  cartStore.cartItemToAdd = cartItem;
  cartStore.pushToCart();

  cartStore.openCartDrawer();
};
</script>
